import React, { Component } from "react";
import mainProduct from "../../imgs/main-product.png";
import mainProductBG from "../../imgs/main-product-bg.png";

import Stake from "../../imgs/stake.png";
export default class ProductPage extends Component {
  state = {
    activeImgSrc: mainProduct,
  };
  setActiveImg = (e) => {
    this.setState({ activeImgSrc: e.target.src });
  };

  render() {
    return (
      <>
        <div className="product-page d-flex flex-row align-items-start">
          <div className="d-flex flex-column align-items-start">
            <div
              style={{
                backgroundImage: `url(${mainProductBG})`,
              }}
              className="current-item"
            >
              <img className="img-fluid" src={this.state.activeImgSrc} />
            </div>
            <div className="product-imgs d-flex flex-row align-items-center mt-4">
              <img
                onClick={(e) => this.setActiveImg(e)}
                className="mini-img"
                src={Stake}
              />
              <img
                onClick={(e) => this.setActiveImg(e)}
                className="mini-img"
                src={mainProduct}
              />
              <img
                onClick={(e) => this.setActiveImg(e)}
                className="mini-img"
                src={Stake}
              />
            </div>
          </div>

          <div className="d-flex flex-column align-items-start ">
            <h6 className="text-dark text-bold text-lg mb-4">
              DG Labs v1 Shirt
            </h6>
            <h6 className="text-dark text-bold text-md mb-4">$30</h6>
            <a className="black-btn text-md regular mb-4">Buy now</a>
            <p className="text-sm text-dark regular desc-text">
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
              nonummy nibhe ismod tincidunt ut laoreet dolore magna aliquam erat
              volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation
              ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
              consequat.
            </p>
            <p className="text-sm text-dark regular desc-text">
              Duis autem vel eum iriure dolor in hendr rit in vulputate velit
              esse molestie consequat, vel illum dolore eu feugiat nulla
              facilisis at vero eros et accumsan et iusto odio
            </p>
          </div>
        </div>
      </>
    );
  }
}
